// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});
/*
export function menuButton_click(event) {
	$w('#columnStrip13').expand();
	$w('#menuButton').hide();
	$w('#closeButton').show();

}

export function closeButton_click(event) {
	$w('#columnStrip13').collapse();
	$w('#menuButton').show();
	$w('#closeButton').hide();
}
*/